import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import routes from 'routes';
import { DESIGN_GALLERY_NAV_GROUPS } from 'components/dev/design-gallery/design-gallery-data';
import styled from 'styled-components';

const Bar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 8px 12px;
  padding: 8px 16px;
  background: #fff5e2;
  border-bottom: 1px solid #ffbc3e;
  font-size: 12px;
  line-height: 1.4;
  color: #042a2a;
`;

const Label = styled.span`
  font-weight: 600;
`;

const Hint = styled.span`
  color: #879494;
`;

const BarLink = styled(Link)`
  font-weight: 600;
  color: #41aaaf;
  text-decoration: none;

  &:hover {
    color: #042a2a;
    text-decoration: underline;
  }
`;

const ExternalLink = styled.a`
  font-weight: 600;
  color: #41aaaf;
  text-decoration: none;

  &:hover {
    color: #042a2a;
    text-decoration: underline;
  }
`;

const GroupBlock = styled.span`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
`;

const GroupLabel = styled.span`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #879494;
  margin-right: 2px;
`;

const Sep = styled.span`
  color: #dbeae3;
`;

export const ButtonGalleryDevBar: React.FC = () => {
  const location = useLocation();
  const hubPath = routes.dev.designSystem.root;
  const onGallery = location.pathname.startsWith('/dev/design-system');

  return (
    <Bar role="note" aria-label="Design system gallery navigation">
      <Label>Design system (temporary)</Label>
      <Hint>Open links in new tabs to compare gallery and app side-by-side.</Hint>
      <BarLink to={hubPath}>Hub</BarLink>
      {DESIGN_GALLERY_NAV_GROUPS.map((group, groupIndex) => (
        <GroupBlock key={group.manualType}>
          {groupIndex > 0 ? <Sep>|</Sep> : null}
          <GroupLabel>{group.label}</GroupLabel>
          {group.categories.map((cat) => (
            <BarLink key={cat.id} to={cat.path}>
              {cat.label}
            </BarLink>
          ))}
        </GroupBlock>
      ))}
      <Sep>|</Sep>
      {onGallery ? (
        <>
          <ExternalLink href={routes.main} target="_blank" rel="noopener noreferrer">
            Main board ↗
          </ExternalLink>
          <BarLink to={routes.main}>Main board (this tab)</BarLink>
        </>
      ) : (
        <ExternalLink href={hubPath} target="_blank" rel="noopener noreferrer">
          Design system ↗
        </ExternalLink>
      )}
    </Bar>
  );
};
